// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3610":"f0d290ed","4001":"f0d290ed","4983":"a4bac765","5552":"f0d290ed","7299":"f0d290ed","9991":"f0d290ed"}[chunkId] + ".chunk.css";
};